import {
  StrictOmit,
} from './typescript';

import {
  components,
} from '@/generated/qmulus/openapi.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';
import {
  colorPalette,
} from '@/utils/color.ts';

type TWorkplaceIdentifier = components['schemas']['WorkplaceIdentifier'];
type TPtDatabaseIdentifier = components['schemas']['PtDatabaseIdentifier'];
export type TWorkplaceAssetAssociation = (StrictOmit<components['schemas']['DataSourceAssociation'], 'dataSourceReference'> & {
  dataSourceReference: TWorkplaceIdentifier,
});
export type TWorkplaceFilter = {
  workplaceIdList?: number[],
  ptDbIdList?: number[],
};

export function getAssetAssociationListByWorkplaceFilter(
  dataSourceNodeList: components['schemas']['DataSource'][],
  filter: TWorkplaceFilter,
): TWorkplaceAssetAssociation[] {
  const associationList: TWorkplaceAssetAssociation[] = [];

  for (const dataSource of dataSourceNodeList) {
    for (const association of dataSource.assetAssociations) {
      if (!association.dataSourceReference) {
        continue;
      }
      const reference = association.dataSourceReference as TWorkplaceIdentifier | TPtDatabaseIdentifier;
      if (
        reference.type === 'WorkplaceIdentifier'
        // filter by ptDbIdList if any was given
        && (
          !filter.ptDbIdList
          || filter.ptDbIdList.length === 0
          || filter.ptDbIdList.includes(reference.ptDbId)
        )
        // filter by workplaceId if any was given
        && (
          !filter.workplaceIdList
          || filter.workplaceIdList.length === 0
          || filter.workplaceIdList.includes(reference.workplaceId)
        )
      ) {
        associationList.push(association as TWorkplaceAssetAssociation);
      }
    }
  }

  return associationList;
}

export const DataSourceColorMap: Record<TComponentValue<'DataSourceType'>, string> = {
  nitrex_plant_manager: colorPalette['color-190'],
  pt9800: colorPalette['color-120'],
  generic: colorPalette['color-199'],
  job_feature: colorPalette['color-180'],
  ml_model: colorPalette['color-209'],
  production_statistics: colorPalette['color-130'],
  signal_builder: colorPalette['color-149'],
  model_builder: colorPalette['color-170'],
};

export const ALL_DATA_SOURCE_TYPES = Object.keys(DataSourceColorMap) as TComponentValue<'DataSourceType'>[];
